import React, { useEffect } from "react";
import { Select } from "antd";
import { setWidgetInSheetParams } from "appRedux/actions/Actions";
import { useDispatch, useSelector } from "react-redux";
import IntlMessages from "@util/IntlMessages";
import { useIntl } from "react-intl";
import { showName } from "@util/Scripts";
import { useWidgetSettings } from "@util/customHooks";
import { Input, Message, Switch, Button, Checkbox } from "../../../BP2Components";
import "./advertisementListSettings.less";

const { Option } = Select;

const AdvertisementListSettings = ({ columns, rows, data, value }) => {
   const { allLanguages, locale } = useSelector(({ settings }) => settings);
   const serviceTranslations = useSelector(({ translations }) => translations.translations);
   const { settings, setSettings, handleChange } = useWidgetSettings(value, {
      translations: [{ translationKey: value.title }],
   });

   const dispatch = useDispatch();
   const intl = useIntl();

   useEffect(() => {
      setSettings((prev) => ({
         ...prev,
         ...allLanguages.reduce((acc, { language }) => {
            const serviceVal = language === locale ? serviceTranslations?.[value.title] : null;
            acc[`name${language}`] = serviceVal || showName(language, value.title, data);
            return acc;
         }, {}),
      }));
   }, []);

   const isDefaultValueValid = (value) => {
      if (filterColumns().find(({ techName }) => techName === value)) {
         return true;
      } else {
         return false;
      }
   };

   const filterColumns = () => {
      return columns.filter(({ title }) => {
         let isValid = true;
         rows.forEach((row) => {
            if (
               row[title] instanceof Array ||
               (typeof row[title] === "object" && row[title] && !row[title].value)
            )
               isValid = false;
         });
         return isValid;
      });
   };

   const handleSubmit = (e) => {
      e.preventDefault();
      dispatch(setWidgetInSheetParams(settings));
      Message.success(intl.formatMessage({ id: "global.saved" }));
   };

   const handleCheckboxChange = (value, title) => {
      if (value === true) {
         setSettings(({ restOfColumns }) => {
            if (restOfColumns === undefined || restOfColumns.length <= 0)
               return { ...settings, restOfColumns: [title] };
            else return { ...settings, restOfColumns: [...restOfColumns, title] };
         });
      } else {
         setSettings(({ restOfColumns }) => {
            if (restOfColumns === undefined || restOfColumns.length <= 0)
               return { ...settings, restOfColumns: [] };
            else
               return {
                  ...settings,
                  restOfColumns: [...restOfColumns.filter((item) => item !== title)],
               };
         });
      }
   };

   const displaySettings = [
      ["mainTitle", "showMainTitleLabel"],
      ["subtitle", "showSubtitleLabel"],
      ["keyInfo", "showKeyInfoLabel"],
      ["subKeyInfo", "showSubKeyInfoLabel"],
      ["label", "showLabelLabel"],
      ["user", "showUserLabel"],
      ["calendar", "showCalendarLabel"],
   ];

   return (
      <form onSubmit={handleSubmit}>
         <div className="widget-settings">
            <div className="widget-settings__inner">
               <label key="listId" className="widget-settings__inner__label">
                  <IntlMessages id="settings.listId" />:
                  <Input
                     onChange={(e) => handleChange(e.target.value, "listId")}
                     defaultValue={settings.listId}
                     name="listId"
                     id="listId"
                     className="listId"
                  ></Input>
               </label>
               <label key="itemsPerPage" className="widget-settings__inner__label">
                  <IntlMessages id="settings.itemsPerPage" />:
                  <Input
                     onChange={(e) => handleChange(e.target.value, "itemsPerPage")}
                     defaultValue={settings.itemsPerPage}
                     name="itemsPerPage"
                     id="itemsPerPage"
                     className="avdertisement-number-input"
                     type="number"
                  ></Input>
               </label>
               {displaySettings.map(([labelName, showLabel]) => {
                  return (
                     <label
                        key={labelName}
                        className="widget-settings__inner__label select_and_switch"
                     >
                        <div className="select-container">
                           <p className="select-container-label">
                              <IntlMessages id={`settings.${labelName}AdvertismentList`} />
                           </p>
                           <Select
                              value={
                                 isDefaultValueValid(settings[labelName])
                                    ? settings[labelName]
                                    : "-"
                              }
                              onChange={(e) => handleChange(e, labelName)}
                           >
                              <Option value={"-"}>-</Option>
                              {filterColumns().map(({ title, techName }, i) => (
                                 <Option value={techName} key={i}>
                                    {title}
                                 </Option>
                              ))}
                           </Select>
                        </div>
                        <div className="show_column_title">
                           <p className="show_column_title-label">
                              <IntlMessages id="settings.showColumnName" />
                           </p>
                           <Switch
                              onChange={(value) => handleChange(value, showLabel)}
                              checked={settings?.[showLabel]}
                              className={"show_column_title-switch"}
                           />
                        </div>
                     </label>
                  );
               })}

               <label key="calendarFormat" className="select_and_switch">
                  <div className="select-container">
                     <p className="select-container-label">
                        <IntlMessages id="settings.calendarFormatAdvertismentList" />
                     </p>
                     <Select
                        value={
                           settings["calendarFormat"] === "date"
                              ? settings["calendarFormat"]
                              : "default"
                        }
                        onChange={(e) => handleChange(e, "calendarFormat")}
                     >
                        <Option value={"default"}>
                           <IntlMessages id="settings.calendarFormatAdvertismentList.default" />
                        </Option>
                        <Option value={"date"}>
                           <IntlMessages id="settings.calendarFormatAdvertismentList.date" />
                        </Option>
                     </Select>
                  </div>
               </label>

               <label
                  key="resOfColumns"
                  className="checkboxes_and_switch widget-settings__inner__label"
               >
                  <p className="columns_checkboxes-label">
                     <IntlMessages id="settings.restOfColumnsAdvertismentList" />
                  </p>
                  <div className="columns_checkboxes">
                     <div className="checkboxes-container">
                        {filterColumns().map(({ title, techName }, i) => {
                           let index;
                           if (!settings.restOfColumns || settings.restOfColumns.length <= 0)
                              index = -1;
                           else
                              index = settings.restOfColumns.findIndex(
                                 (column) => column === techName,
                              );

                           return (
                              <Checkbox
                                 key={i}
                                 name={techName}
                                 defaultChecked={index !== -1 ? true : false}
                                 onChange={(e) => handleCheckboxChange(e.target.checked, techName)}
                              >
                                 {title}
                              </Checkbox>
                           );
                        })}
                     </div>
                  </div>
               </label>
               <div className="show_column_title">
                  <label className="widget-settings__inner__label">
                     <p className="show_column_title-label">
                        <IntlMessages id="settings.showRestOfColumnsName" />
                     </p>
                     <Switch
                        onChange={(value) => handleChange(value, "showRestOfColumnsLabel")}
                        checked={settings.showRestOfColumnsLabel}
                        className={"show_column_title-switch"}
                     />
                  </label>
               </div>
            </div>
            <Button buttonType="primary" htmlType="submit">
               <IntlMessages id="global.preview" />
            </Button>
         </div>
      </form>
   );
};

export default AdvertisementListSettings;
